/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line jira/filename-case
import type { HTMLAttributes } from 'react';
import { jsx } from '@atlaskit/css';

type SpacerProps = HTMLAttributes<HTMLDivElement> & {
	height: string;
};

export const Spacer = ({ children, className, height, style, ...rest }: SpacerProps) => {
	return (
		<div
			{...rest}
			// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- to support "styled" wrappers
			className={className}
			// eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- to support dynamic styles
			style={{ ...style, height }}
		>
			{children}
		</div>
	);
};
